<template>
  <section class="py-9 tablet:py-20">
    <div class="container-wrap">
      <ul class="column-421">
        <li class="tablet:col-span-2">
          <h2 class="text-h2 mb-10 tablet:line-clamp-2">
            {{ title }}
          </h2>
          <TheRichText
            v-if="descriptionHtml || description"
            class="mb-10 w-full text-sm leading-6 text-gray-700 tablet:line-clamp-7 tablet:text-base"
            :text="descriptionHtml || description"
            :is-html="!!descriptionHtml"
          />
        </li>
        <li v-for="item in items" :key="hash(item)" class="mb-4">
          <h3 class="text-h5 mb-2 truncate">{{ item.name }}</h3>
          <div
            class="mb-2 truncate bg-gradient-to-r from-brand-400 to-blue-400 bg-clip-text text-5xl font-bold leading-normal text-transparent"
          >
            {{ item.subtitle }}
          </div>
          <TheRichText
            class="text-sm leading-6 text-gray-700 tablet:line-clamp-6"
            :text="item.descriptionHtml || item.description"
            :is-html="!!item.descriptionHtml"
          />
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
  /**
   * @see https://www.figma.com/design/QJ3ZvEbUHI9xI11iudYf8U/Advantech-WISE-Library?node-id=12796-23824&t=89PIFDiQEC4zcSbf-0
   */

  import hash from 'object-hash';

  interface IItem {
    name: string;
    subtitle: string;
    description: string;
    descriptionHtml?: string;
  }

  interface IProps {
    title: string;
    description?: string;
    descriptionHtml?: string;
    items: IItem[];
    theme?: TTheme;
  }

  withDefaults(defineProps<IProps>(), {
    description: undefined,
    descriptionHtml: undefined,
    theme: 'blue',
  });

  export type { IItem };
</script>
